<template>
<div>
        <div class="page-header">
          <div class="container-fluid">
            <h2 class="h5 no-margin-bottom">Ekip Tanımla</h2>
          </div>
        </div>

  <section class="no-padding-top no-padding-bottom">
  <div class="container-fluid">
  <div class="row">
              <div class="col-12">
                <div class="block">
                    <div class="block-body">
                      <form @submit.prevent="sendNewPost">
                        <div class="row">

                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Kodu</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.kodu" />
                        </div>
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Alias</label>
                          <input name="title" type="text" class="form-control" v-model="newPost.alias" />  
                        </div>
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Lider Seç</label>
                          <select v-model = "newPost.lider"  class="form-control">
                            <option selected value="0">Lideri</option>
                            <option v-for="items in kullanici" :key="items.kid" :value="items.kid">{{items.isim}}</option>
                          </select>
                        </div>
                        <div class="col-lg-3 col-12">
                          <input type="submit" value="Kaydet" class="btn btn-primary w-100 mt-4">
                        </div>
                        </div>
                      </form>
                    </div>
                  </div>
              </div>
              <div class="col-12">
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Ekip Kodu</th>
                          <th>Ekip Alias</th>
                          <th>Ekip Lideri</th>
                          <th>Detay</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="post in posts" :key="post.kid">
                          <td>{{post.kodu}}</td>
                          <td>{{post.ekip}}</td>
                          <td>{{post.lider}}</td>
                          <td>
                          <router-link :to="`/detay/ekip/${post.id*8589}`">Detay</router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>       
            </div>
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div class="container-fluid text-center">
                    Sistem Hatası : {{ errors.length }}  {{ errors.message }}        
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div> 
      </div>
</template>

<script>
  export default {

    async created() {
      //await this.getPostsAsync(this.newPost.table);
      this.progres.inprogres = true
      this.yetki();
    },
    data() {
      return {
        inProgress: false,
        posts: [],
        errors: [],
        kodu : '',
        alias : '',
        ayar : this.$request.ayar(),
        bolge:'',
        ekip:[],
        currentTag: 'All',
        kullanici:[],
        newPost: {
          kodu: '',
          alias:'',
          firma:this.$request.ayar().firmaid,
          table : 'ekip',
          bolge:'',
          lider:'',
        },
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      }               
      };
    },
    methods: {
          yetki: function(){
          if (this.$helper.sayfayetki(870357)){
            this.getPostsAsync()
          }
          else{
            alert('Bu alanı kullanım yetkiniz yok')
            this.$router.go(-1)
          }
        },

        kullanicigetir(){
          this.$request.get("kullanici/"+this.newPost.firma)
          .then(res => {this.kullanici = res.results
          this.progres.inprogres =false
          })
          .catch(err => (this.error.push(err)))
        },   
        getPostsAsync() {
        this.progres.inprogres = true
        //if (value !=0){
          this.$request.get("/ekiptanim/"+this.newPost.firma)
            .then(res=> {
              this.posts = res.results
              this.kullanicigetir();
            })
            .catch(err => {alert(err)})
       // }
      },
      sendNewPost() {
        
          this.$request.post("/ekip/",this.newPost )
          .then(res => {
            this.$swal("Ekip Tanımlandı")
          })
          .catch(err => {
            this.$swal(err)
          })
      },
    },
   
  };
</script>
<style scoped>
.form-control{height: calc(2.4rem + 15px);font-size: 16px; border-radius:0%;}
</style>


// WEBPACK FOOTER //
// src/views/kullanici/ekip.vue